import React from "react";
import PropTypes from "prop-types";
import colors from "app/theme/base/colors";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Uncaught error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            height: "100vh",
            width: "100vw",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: colors.background.default,
            fontFamily: "system-ui, -apple-system, BlinkMacSystemFont",
          }}
        >
          <div
            style={{
              textAlign: "center",
              padding: "32px",
              borderRadius: "12px",
              backgroundColor: colors.background.paper,
              border: `1px solid ${colors.grey[300]}`,
              maxWidth: "420px",
            }}
          >
            <h2 style={{ marginBottom: "12px", color: colors.text.primary }}>Error inesperado</h2>
            <p style={{ marginBottom: "20px", color: colors.text.secondary }}>
              Algo salió mal. Intentalo de nuevo mas tarde
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: "10px 16px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: colors.primary.main,
                color: colors.white.main,
                fontSize: "14px",
                cursor: "pointer",
              }}
            >
              Recargar
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};

export default ErrorBoundary;
